import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Alert from "@mui/material/Alert";

const TokenDialog = ({ token, onClose }) => (
  <Dialog open={Boolean(token)} onClose={onClose} fullWidth maxWidth="sm">
    <DialogTitle>Ключ выпущен</DialogTitle>
    <DialogContent>
      <Alert severity="warning" sx={{ mb: 2 }}>
        Скопируйте ключ сейчас — второй раз он не отобразится.
      </Alert>
      <TextField
        fullWidth
        multiline
        value={token || ""}
        InputProps={{ readOnly: true }}
      />
    </DialogContent>
    <DialogActions>
      <Button onClick={() => navigator.clipboard.writeText(token)}>
        Скопировать
      </Button>
      <Button variant="contained" onClick={onClose}>
        Готово
      </Button>
    </DialogActions>
  </Dialog>
);

export default TokenDialog;
